// import React, { useEffect, useState } from "react";
// import { Card, CardBody, CardHeader, Container, Row, Col } from "reactstrap";
// import TotalUsersCard from "../../Components/Cards/TotalUserCard";
// import TotalMealCard from "../../Components/Cards/TotalMealCard";
// import ActiveDietPlanCard from "../../Components/Cards/ActiveDietPlanCard";
// import ActiveSubscriptions from "../../Components/Cards/ActiveSubscriptions";
// import TotalRestaurantCard from "../../Components/Cards/TotalRestaurantCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchDashboardDataList } from "../../slices/thunks";
// import { createSelector } from "reselect";
// import Loader from "../../Components/Common/Loader";
// import logo from "../../assets/images/sa.png";

// const Dashboard = () => {
//   const dispatch = useDispatch();

//   const selectDashboardState = (state) => state;

//   const dashboardSelector = createSelector(selectDashboardState, (state) => ({
//     dashboard: state.Dashboard.dashboardData,
//     loading: state.Dashboard.loading,
//     error: state.Dashboard.error,
//   }));

//   const { dashboard, loading, error } = useSelector(dashboardSelector);
//   useEffect(() => {
//     // dispatch(fetchDashboardDataList());
//   }, []);

//   document.title = "Dashboard";

//   return (
//     // <div className="page-content">
//     //   <Container fluid>
//     //     {loading && (
//     //       <div>
//     //         <Loader />
//     //       </div>
//     //     )}

//     //     {!loading && !error && (
//     //       <Card>
//     //         <CardHeader className="d-flex align-items-center flex-wrap gap-2">
//     //           <h4 className="card-title mb-0 me-3"> Dashboard</h4>
//     //         </CardHeader>
//     //       </Card>
//     //     )}
//     //   </Container>
//     // </div>

//     <div className="page-content">
//       <Container fluid>
//         {loading && (
//           <div>
//             <Loader />
//           </div>
//         )}

//         {!loading && !error && (
//           <div
//             style={{
//               height: "75vh", // full height area
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexDirection: "column",
//             }}
//           >
//             <img
//               src={logo}
//               alt="Dashboard Logo"
//               style={{
//                 width: "220px",
//                 height: "220px",
//                 objectFit: "contain",
//                 opacity: 0.9,
//               }}
//             />
//             <h2 className="mt-3 text-muted">Welcome </h2>
//           </div>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default Dashboard;

// import React, { useEffect, useState } from "react";
// import { Card, CardBody, CardHeader, Container, Row, Col } from "reactstrap";
// import TotalUsersCard from "../../Components/Cards/TotalUserCard";
// import TotalMealCard from "../../Components/Cards/TotalMealCard";
// import ActiveDietPlanCard from "../../Components/Cards/ActiveDietPlanCard";
// import ActiveSubscriptions from "../../Components/Cards/ActiveSubscriptions";
// import TotalRestaurantCard from "../../Components/Cards/TotalRestaurantCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchDashboardDataList } from "../../slices/thunks";
// import { createSelector } from "reselect";
// import Loader from "../../Components/Common/Loader";
// import logo from "../../assets/images/sl.png";

// const Dashboard = () => {
//   const dispatch = useDispatch();

//   const selectDashboardState = (state) => state;

//   const dashboardSelector = createSelector(selectDashboardState, (state) => ({
//     dashboard: state.Dashboard.dashboardData,
//     loading: state.Dashboard.loading,
//     user: state.Aprofile.user,

//     error: state.Dashboard.error,
//   }));

//   const { dashboard, loading, error, user } = useSelector(dashboardSelector);
//   useEffect(() => {
//     // dispatch(fetchDashboardDataList());
//   }, []);

//   document.title = "Dashboard";

//   return (
//     // <div className="page-content">
//     //   <Container fluid>
//     //     {loading && (
//     //       <div>
//     //         <Loader />
//     //       </div>
//     //     )}

//     //     {!loading && !error && (
//     //       <Card>
//     //         <CardHeader className="d-flex align-items-center flex-wrap gap-2">
//     //           <h4 className="card-title mb-0 me-3"> Dashboard</h4>
//     //         </CardHeader>
//     //       </Card>
//     //     )}
//     //   </Container>
//     // </div>

//     <div className="page-content">
//       <Container fluid>
//         {loading && (
//           <div>
//             <Loader />
//           </div>
//         )}

//         {!loading && !error && (
//           <div
//             style={{
//               height: "75vh", // full height area
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexDirection: "column",
//             }}
//           >
//             <img
//               src={user?.profilePic}
//               alt="Dashboard Logo"
//               style={{
//                 width: "220px",
//                 height: "220px",
//                 objectFit: "contain",
//                 opacity: 0.9,
//               }}
//             />
//             <h4 className="mt-3 text-muted">Welcome to {user?.name}</h4>
//           </div>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default Dashboard;

import { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  Truck,
  Users,
  UserCheck,
  UserX,
  TrendingUp,
  TrendingDown,
  Package,
  CheckCircle,
  XCircle,
  Activity,
  AlertCircle,
  BarChart2,
  PieChart,
  DollarSign,
  Calendar,
  Clock,
  Eye,
  ArrowUpRight,
  ArrowDownRight,
  CreditCard,
} from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { fetchDashboardDataList } from "../../slices/thunks";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectDashboardState = (state) => state;

  const dashboardSelector = createSelector(selectDashboardState, (state) => ({
    dashboardData: state.Dashboard.dashboardData,
    dashboardBillingData: state.Dashboard.dashboardBillingData,

    loading: state.Dashboard.loading,
    user: state.Aprofile.user,
    error: state.Dashboard.error,
  }));

  const { dashboardData, dashboardBillingData, loading, error, user } =
    useSelector(dashboardSelector);

  useEffect(() => {
    dispatch(fetchDashboardDataList());
  }, [dispatch]);

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  // Calculate percentages
  const vehicleActivePercentage = dashboardData?.totalVehicleCount
    ? (
        (dashboardData?.activeVehicleCount / dashboardData?.totalVehicleCount) *
        100
      ).toFixed(1)
    : 0;

  const customerActivePercentage = dashboardData?.totalCustomerCount
    ? (
        (dashboardData?.activeCustomerCount /
          dashboardData?.totalCustomerCount) *
        100
      ).toFixed(1)
    : 0;

  const supplierActivePercentage = dashboardData?.totalSuppliersCount
    ? (
        (dashboardData?.activeSuppliersCount /
          dashboardData?.totalSuppliersCount) *
        100
      ).toFixed(1)
    : 0;

  const statsCards = [
    // Vehicles Section
    {
      title: "Total Trips",
      value: dashboardBillingData?.tripCount || 0,
      icon: <Truck size={24} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      bgLight: "#f0f4ff",
      iconColor: "#667eea",
      trend: null,
      category: "vehicles",
      navigation: "/bookTrip",
    },
    {
      title: "Total Bills(GST)",
      value: dashboardBillingData?.billCount || 0,
      icon: <CheckCircle size={24} />,
      gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
      bgLight: "#d1fae5",
      iconColor: "#10B981",
      trend: vehicleActivePercentage,
      trendUp: true,
      category: "vehicles",
      navigation: "/salesInvoiceGST",
    },
    {
      title: "Total Charges Bill",
      value: dashboardBillingData?.billChargesCount || 0,
      icon: <CreditCard size={24} />,
      gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
      bgLight: "#fee2e2",
      iconColor: "#EF4444",
      trend: (100 - vehicleActivePercentage).toFixed(1),
      trendUp: false,
      category: "vehicles",
      navigation: "/invoiceCharges",
    },

    // Customers Section
    {
      title: "Total Customers",
      value: dashboardData?.totalCustomerCount || 0,
      icon: <Users size={24} />,
      gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
      bgLight: "#dbeafe",
      iconColor: "#3B82F6",
      trend: null,
      category: "customers",
    },
    {
      title: "Active Customers",
      value: dashboardData?.activeCustomerCount || 0,
      icon: <UserCheck size={24} />,
      gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
      bgLight: "#d1fae5",
      iconColor: "#10B981",
      trend: customerActivePercentage,
      trendUp: true,
      category: "customers",
    },
    {
      title: "Inactive Customers",
      value: dashboardData?.inactiveCustomerCount || 0,
      icon: <UserX size={24} />,
      gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
      bgLight: "#fee2e2",
      iconColor: "#EF4444",
      trend: (100 - customerActivePercentage).toFixed(1),
      trendUp: false,
      category: "customers",
    },

    // Suppliers Section
    {
      title: "Total Suppliers",
      value: dashboardData?.totalSuppliersCount || 0,
      icon: <Package size={24} />,
      gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
      bgLight: "#fef3c7",
      iconColor: "#F59E0B",
      trend: null,
      category: "suppliers",
    },
    {
      title: "Active Suppliers",
      value: dashboardData?.activeSuppliersCount || 0,
      icon: <Activity size={24} />,
      gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
      bgLight: "#d1fae5",
      iconColor: "#10B981",
      trend: supplierActivePercentage,
      trendUp: true,
      category: "suppliers",
    },
    {
      title: "Inactive Suppliers",
      value:
        dashboardData?.totalSuppliersCount -
        dashboardData?.activeSuppliersCount,
      icon: <AlertCircle size={24} />,
      gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
      bgLight: "#fee2e2",
      iconColor: "#EF4444",
      trend: (100 - supplierActivePercentage).toFixed(1),
      trendUp: false,
      category: "suppliers",
    },
  ];

  // Summary cards for quick overview
  const summaryCards = [
    {
      title: "Active Tenent",
      total: dashboardData?.dashboardData?.activeTenant || 0,
      active: dashboardData?.dashboardData?.activeTenant,
      inactive: dashboardData?.dashboardData?.activeTenant,
      icon: <CheckCircle size={32} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      activePercentage: vehicleActivePercentage,
    },
    {
      title: "Inactive Tenent",
      total: dashboardData?.dashboardData?.inactiveTenant || 0,
      active: dashboardData?.dashboardData?.inactiveTenant,
      inactive: dashboardData?.dashboardData?.inactiveTenant,
      icon: <XCircle size={32} />,
      gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
      activePercentage: customerActivePercentage,
    },
    {
      title: "Total Tenents",
      total: dashboardData?.dashboardData?.tenantCount || 0,
      active: dashboardData?.dashboardData?.tenantCount,
      inactive:
        dashboardData?.totalSuppliersCount -
        dashboardData?.activeSuppliersCount,
      icon: <Users size={32} />,
      gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
      activePercentage: supplierActivePercentage,
    },
  ];

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading Dashboard...</p>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* Header Section */}
        <div className="dashboard-header">
          <div className="header-content">
            <div>
              <h1 className="dashboard-title">{user?.name} Dashboard</h1>
              <p className="dashboard-subtitle">
                Real-time overview of your transport operations
              </p>
            </div>
            <div className="header-meta">
              <div className="meta-item">
                <Calendar size={18} />
                <span>
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
              </div>
              <div className="meta-item">
                <Clock size={18} />
                <span>
                  {new Date().toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Summary Cards Section */}
        <Row className="summary-section">
          {summaryCards.map((card, index) => (
            <Col lg={4} md={6} xs={12} key={index}>
              <div className="summary-card">
                <div className="summary-header">
                  <div
                    className="summary-icon"
                    style={{ background: card.gradient }}
                  >
                    {card.icon}
                  </div>
                  <div className="summary-title-section">
                    <h3 className="summary-title">{card.title}</h3>
                  </div>
                </div>

                <div className="summary-stats">
                  <div className="stat-item success">
                    <div className="stat-label">
                      <CheckCircle size={16} />
                      <span>Total Count</span>
                    </div>
                    <div className="stat-value">{card.total}</div>
                  </div>
                  {/* <div className="stat-divider"></div>
                  <div className="stat-item danger">
                    <div className="stat-label">
                      <XCircle size={16} />
                      <span>Inactive</span>
                    </div>
                    <div className="stat-value">{card.inactive}</div>
                  </div> */}
                </div>

                {/* <div className="summary-progress">
                  <div className="progress-info">
                    <span className="progress-label">Active Rate</span>
                    <span className="progress-percentage">
                      {card.activePercentage}%
                    </span>
                  </div>
                  <div className="progress-bar-container">
                    <div
                      className="progress-bar-fill"
                      style={{
                        width: `${card.activePercentage}%`,
                        background: card.gradient,
                      }}
                    ></div>
                  </div>
                </div> */}
              </div>
            </Col>
          ))}
        </Row>

        {/* Detailed Stats Grid */}

        {/* Internal CSS */}
        <style>
          {`
          /* ==================== BASE STYLES ==================== */
          

          /* ==================== LOADING ==================== */
          .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          }

          .loading-spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #e5e7eb;
            border-top-color: #667eea;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          .loading-text {
            margin-top: 16px;
            font-size: 16px;
            font-weight: 600;
            color: #4b5563;
          }

          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }

          /* ==================== HEADER ==================== */
          .dashboard-header {
            background: white;
            border-radius: 16px;
            padding: 24px;
            margin-bottom: 24px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            animation: fadeInDown 0.6s ease-out;
          }

          .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px;
          }

          .dashboard-title {
            margin: 0 0 8px 0;
            font-size: 28px;
            font-weight: 700;
            color: #1f2937;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .dashboard-subtitle {
            margin: 0;
            font-size: 14px;
            color: #6b7280;
          }

          .header-meta {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
          }

          .meta-item {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 16px;
            background: #f9fafb;
            border-radius: 8px;
            font-size: 14px;
            color: #4b5563;
            font-weight: 500;
          }

          /* ==================== SUMMARY SECTION ==================== */
          .summary-section {
            margin-bottom: 32px;
            animation: fadeInUp 0.6s ease-out 0.1s both;
          }

          .summary-card {
            background: white;
            border-radius: 16px;
            padding: 24px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            height: 100%;
            margin-bottom: 24px;
          }

          .summary-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
          }

          .summary-header {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 24px;
          }

          .summary-icon {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          }

          .summary-title-section {
            flex: 1;
          }

          .summary-title {
            margin: 0 0 4px 0;
            font-size: 18px;
            font-weight: 700;
            color: #1f2937;
          }

          .summary-total {
            margin: 0;
            font-size: 14px;
            color: #6b7280;
            font-weight: 500;
          }

          .summary-stats {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 16px;
            background: #f9fafb;
            border-radius: 12px;
          }

          .stat-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .stat-label {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .stat-item.success .stat-label {
            color: #10b981;
          }

          .stat-item.danger .stat-label {
            color: #ef4444;
          }

          .stat-value {
            font-size: 24px;
            font-weight: 700;
            color: #1f2937;
          }

          .stat-divider {
            width: 2px;
            height: 40px;
            background: #e5e7eb;
            border-radius: 2px;
          }

          .summary-progress {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .progress-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .progress-label {
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .progress-percentage {
            font-size: 14px;
            font-weight: 700;
            color: #1f2937;
          }

          .progress-bar-container {
            height: 8px;
            background: #e5e7eb;
            border-radius: 10px;
            overflow: hidden;
          }

          .progress-bar-fill {
            height: 100%;
            border-radius: 10px;
            transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
            animation: progressGrow 1.5s ease-out;
          }

          @keyframes progressGrow {
            from {
              width: 0%;
            }
          }

          /* ==================== SECTION HEADER ==================== */
          .section-header {
            margin: 48px 0 24px 0;
            animation: fadeInUp 0.6s ease-out 0.2s both;
          }

          .section-title-wrapper {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 8px;
          }

          .section-icon {
            color: #667eea;
          }

          .section-title {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #1f2937;
          }

          .section-subtitle {
            margin: 0;
            font-size: 14px;
            color: #6b7280;
            padding-left: 36px;
          }

          /* ==================== CATEGORY SECTION ==================== */
          .category-section {
            margin-bottom: 32px;
            animation: fadeInUp 0.6s ease-out 0.3s both;
          }

          .category-header {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 20px;
            background: white;
            border-radius: 12px;
            margin-bottom: 20px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
          }

          .category-header h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 700;
            color: #1f2937;
          }

          .category-header.vehicles {
            border-left: 4px solid #667eea;
          }

          .category-header.customers {
            border-left: 4px solid #3B82F6;
          }

          .category-header.suppliers {
            border-left: 4px solid #F59E0B;
          }

          /* ==================== STAT CARDS ==================== */
          .stat-card {
            background: white;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            height: 100%;
            display: flex;
            flex-direction: column;
          }

          .stat-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
          }

          .stat-card-header {
            padding: 24px;
            display: flex;
            align-items: center;
            gap: 16px;
          }

          .stat-icon {
            width: 56px;
            height: 56px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s ease;
          }

          .stat-card:hover .stat-icon {
            transform: scale(1.1);
          }

          .stat-info {
            flex: 1;
          }

          .stat-title {
            margin: 0 0 8px 0;
            font-size: 14px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .stat-value-main {
            margin: 0;
            font-size: 32px;
            font-weight: 700;
            color: #1f2937;
          }

          .stat-trend {
            padding: 12px 24px;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 600;
            border-top: 1px solid #f3f4f6;
          }

          .stat-trend.up {
            color: #10b981;
            background: linear-gradient(to right, transparent, #d1fae5);
          }

          .stat-trend.down {
            color: #ef4444;
            background: linear-gradient(to right, transparent, #fee2e2);
          }

          .trend-label {
            margin-left: 4px;
            font-size: 12px;
            color: #6b7280;
            font-weight: 500;
          }

          .stat-card-footer {
            padding: 16px 24px;
            display: flex;
            justify-content: center;
            margin-top: auto;
          }

          .view-details-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 8px;
            color: white;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .view-details-btn:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateX(4px);
          }

          /* ==================== ANIMATIONS ==================== */
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* ==================== RESPONSIVE ==================== */
          @media (max-width: 991px) {
            .dashboard-container {
              padding: 16px;
            }

            .dashboard-header {
              padding: 20px;
            }

            .dashboard-title {
              font-size: 24px;
            }

            .header-content {
              flex-direction: column;
              align-items: flex-start;
            }

            .header-meta {
              width: 100%;
            }

            .meta-item {
              flex: 1;
              justify-content: center;
            }

            .summary-card {
              margin-bottom: 16px;
            }

            .summary-icon {
              width: 50px;
              height: 50px;
            }

            .summary-title {
              font-size: 16px;
            }

            .stat-value {
              font-size: 20px;
            }

            .section-title {
              font-size: 20px;
            }

            .stat-value-main {
              font-size: 28px;
            }
          }

          @media (max-width: 767px) {
            .dashboard-title {
              font-size: 20px;
            }

            .dashboard-subtitle {
              font-size: 13px;
            }

            .meta-item {
              font-size: 12px;
              padding: 6px 12px;
            }

            .summary-header {
              flex-direction: column;
              align-items: flex-start;
            }

            .summary-stats {
              flex-direction: column;
              gap: 12px;
            }

            .stat-divider {
              width: 100%;
              height: 2px;
            }

            .stat-card-header {
              flex-direction: column;
              align-items: flex-start;
            }

            .stat-icon {
              width: 48px;
              height: 48px;
            }

            .stat-value-main {
              font-size: 24px;
            }
          }

          @media (max-width: 575px) {
            .section-subtitle {
              padding-left: 0;
            }

            .category-header {
              padding: 10px 16px;
            }

            .category-header h3 {
              font-size: 16px;
            }
          }

          /* ==================== PRINT STYLES ==================== */
          @media print {
            .dashboard-container {
              background: white;
            }

            .view-details-btn {
              display: none;
            }

            .stat-card,
            .summary-card,
            .dashboard-header {
              box-shadow: none;
              border: 1px solid #e5e7eb;
            }
          }
        `}
        </style>
      </Container>
    </div>
  );
};

export default Dashboard;
